export const MIME_MAP: Record<string, readonly string[]> = {
  pdf: ["application/pdf"],
  xlsx: [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ],
  jpg: ["image/jpeg"],
  jpeg: ["image/jpeg"],
  png: ["image/png"],
  webp: ["image/webp"],
  txt: ["text/plain"],
  doc: ["application/msword"],
  docx: [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ],
  ppt: ["application/vnd.ms-powerpoint"],
  pptx: [
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ],
};

export const ALLOWED_EXTENSIONS = Object.keys(MIME_MAP) as Array<
  keyof typeof MIME_MAP
>;

export function getFileExtension(fileName: string): string {
  const lastDot = fileName.lastIndexOf(".");
  if (lastDot < 0) return "";
  return fileName.slice(lastDot + 1).toLowerCase();
}

export function getAllowedMimeTypes(extension: string): readonly string[] {
  return MIME_MAP[extension.toLowerCase()] ?? [];
}

export function isAllowedExtension(extension: string): boolean {
  return extension.toLowerCase() in MIME_MAP;
}

export function isAllowedMimeForExtension(
  extension: string,
  mimeType: string
): boolean {
  const allowed = getAllowedMimeTypes(extension);
  if (allowed.length === 0) return false;
  if (mimeType === "application/octet-stream") return true;
  return allowed.includes(mimeType);
}
